import React, { PureComponent } from 'react';
import { Flex } from '../../common/Flex';
import { Button, Checkbox, Radio, Space } from 'antd';
import { ModalPanelProps } from '../DashboardModal';
import './SettingsPanel.less';
import { CapacityModel } from 'app/model/CORE';
import AppContext from '../../../common/context/AppContext';
import { DashboardSettingsUpdateEvent } from 'app/common/eventbus/Events';
import { ConvectionSource } from 'app/model/SOL49';
import ConditionalRender from 'app/common/components/ConditionalRender';

export interface DashboardSettings {
    capacityModel: CapacityModel;
    enableSoundNotification: boolean;
    convectionSource: ConvectionSource;
}

interface SettingsPanelProps extends ModalPanelProps {}

interface SettingsPanelState {
    settings: DashboardSettings;
}

export class SettingsPanel extends PureComponent<SettingsPanelProps, SettingsPanelState> {
    public static INITIAL_WIDTH = '25em';

    constructor(props) {
        super(props);

        this.state = {
            settings: { ...AppContext.dashboardSettings },
        };
    }

    handleApply = () => {
        DashboardSettingsUpdateEvent.fireEvent(this.state.settings);
        this.props.onClose();
    };

    updateSettingsProperty = (update: Partial<DashboardSettings>) => {
        this.setState({
            settings: Object.assign({}, this.state.settings, update),
        });
    };

    render() {
        return (
            <Flex direction="vertical" className="settings-panel overflow">
                <Flex className="modal-title header" grow={false} shrink={false}>
                    <Flex direction="vertical">
                        <Flex className="title">SETTINGS</Flex>
                        <Flex style={{ justifyContent: 'center' }}>{/*TODO*/}</Flex>
                    </Flex>
                </Flex>
                <Flex direction="vertical" className="settings-content">
                    <Flex className="label">
                        <Checkbox
                            checked={this.state.settings.capacityModel === CapacityModel.WCM_NRP}
                            onChange={value =>
                                this.updateSettingsProperty({
                                    capacityModel: value.target.checked ? CapacityModel.WCM_NRP : CapacityModel.CCM,
                                })
                            }>
                            WCM Enabled
                        </Checkbox>
                        <Checkbox
                            checked={this.state.settings.enableSoundNotification}
                            onChange={value =>
                                this.updateSettingsProperty({ enableSoundNotification: value.target.checked })
                            }>
                            Sound notification
                        </Checkbox>
                    </Flex>
                    <Flex className="label" style={{ gap: '1em' }}>
                        <span>Convection source:</span>
                        <Radio.Group
                            onChange={v => this.updateSettingsProperty({ convectionSource: v.target.value })}
                            value={this.state.settings.convectionSource}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            }}>
                            <ConditionalRender condition={!AppContext.isOpsBaseline()}>
                                <Radio value={ConvectionSource.METSAFE}>METSAFE</Radio>
                            </ConditionalRender>
                            <Radio value={ConvectionSource.DWD}>EuFoCS (EUMETNET)</Radio>
                            <Radio value={ConvectionSource.DWD_ICONV}>iConv (DWD)</Radio>
                        </Radio.Group>
                    </Flex>
                </Flex>
                <Flex className="button-panel" grow={false} shrink={false}>
                    <SettingsButtonPanel onClose={this.props.onClose} onApply={this.handleApply} />
                </Flex>
            </Flex>
        );
    }
}

interface SettingsButtonPanelProps {
    onClose?(): void;
    onApply?(): void;
}

class SettingsButtonPanel extends PureComponent<SettingsButtonPanelProps> {
    handleCloseClick = () => {
        this.props.onClose?.();
    };
    render() {
        return (
            <Space>
                <Button key="close" onClick={this.handleCloseClick}>
                    Close
                </Button>
                <Button key="apply" onClick={this.props?.onApply}>
                    Apply
                </Button>
            </Space>
        );
    }
}
